__turbopack_context__.v({
  "article-list-item": "TT3juW_article-list-item",
  "article-post-card": "TT3juW_article-post-card",
  "article-thumb": "TT3juW_article-thumb",
  "block-container": "TT3juW_block-container",
  "block-content": "TT3juW_block-content",
  "block-footer": "TT3juW_block-footer",
  "block-footer-action": "TT3juW_block-footer-action",
  "block-header": "TT3juW_block-header",
  "block-header-actions": "TT3juW_block-header-actions",
  "block-header-actions-desktop": "TT3juW_block-header-actions-desktop",
  "block-header-controls-only": "TT3juW_block-header-controls-only",
  "block-header-end": "TT3juW_block-header-end",
  "block-header-white": "TT3juW_block-header-white",
  "block-header-with-view-more": "TT3juW_block-header-with-view-more",
  "block-list-wrapper": "TT3juW_block-list-wrapper",
  "clean": "TT3juW_clean",
  "divider": "TT3juW_divider",
  "full-item": "TT3juW_full-item",
  "grid-item": "TT3juW_grid-item",
  "list-item": "TT3juW_list-item",
  "movers-column-header": "TT3juW_movers-column-header",
  "movers-column-header-gainers": "TT3juW_movers-column-header-gainers",
  "movers-column-header-losers": "TT3juW_movers-column-header-losers",
  "movers-column-icon": "TT3juW_movers-column-icon",
  "quote-card": "TT3juW_quote-card",
  "quote-card-header": "TT3juW_quote-card-header",
  "quote-card-logo": "TT3juW_quote-card-logo",
  "quote-card-name": "TT3juW_quote-card-name",
  "quote-card-price": "TT3juW_quote-card-price",
  "resource-group": "TT3juW_resource-group",
  "short-item": "TT3juW_short-item",
});
